module.exports = __webpack_public_path__ + "static/media/main-screen-card-events.a3b15aa1.png";